// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".uploaded-document-popover__popover{position:absolute;top:50%;left:50%;transform:translateX(-50%) translateY(-50%);display:none}.uploaded-document-popover__popover--show{display:block;background:rgba(249,251,255,.3);width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
